import { intervalToDuration, addDays } from 'date-fns';

export const getIntervalFromDates = (start, end) => {
  const { years, months, days } = intervalToDuration({
    start,
    end: addDays(end, 1),
  });

  return { years, months, days };
};
